import { Stack } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import {
  FormikMultiAutocompleteField,
  FormikTextField,
} from '@components/FormikFields';

const messages = defineMessages({
  firstName: {
    id: 'GLOBAL.firstName',
    defaultMessage: 'First Name',
  },
  middleName: {
    id: 'GLOBAL.middleName',
    defaultMessage: 'Middle Name',
  },
  lastName: {
    id: 'GLOBAL.lastName',
    defaultMessage: 'Last Name',
  },
  email: {
    id: 'GLOBAL.email',
    defaultMessage: 'Email',
  },
  user: {
    id: 'newAccountForm.user',
    defaultMessage: 'User #{number}',
  },
  roles: {
    id: 'admin.users.roles',
    defaultMessage: 'Roles',
  },
});

interface NewUserFormProps {
  index: number;
  roleOptions: { label: string; value: string }[];
}

const NewUserForm: React.FC<NewUserFormProps> = ({
  index = 0,
  roleOptions,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <FormikMultiAutocompleteField
        name={`members.${index}.roles`}
        options={roleOptions}
        label={formatMessage(messages.roles)}
        getOptionLabel={(option) =>
          typeof option === 'string' ? option : option.label
        }
      />
      <Stack direction="row" spacing={2}>
        <FormikTextField
          label={formatMessage(messages.firstName)}
          name={`members.${index}.firstName`}
          fullWidth
        />
        <FormikTextField
          label={formatMessage(messages.middleName)}
          name={`members.${index}.middleName`}
          fullWidth
        />
        <FormikTextField
          label={formatMessage(messages.lastName)}
          name={`members.${index}.lastName`}
          fullWidth
        />
      </Stack>
      <Stack direction="row" spacing={2}>
        <FormikTextField
          label={formatMessage(messages.email)}
          name={`members.${index}.email`}
          type="email"
          fullWidth
        />
      </Stack>
    </>
  );
};

export default NewUserForm;
